export default __webpack_public_path__ + "static/media/11_1_0.7fe024de.png";